<template>
	<el-card class="guest-container" v-loading="loading">
		<template #header>
		  <div class="header">
			  <el-button type="primary" size="small" icon="el-icon-plus" @click="editBlog('')">新增</el-button>
			  <el-button type="warning" size="small" icon="el-icon-plus" @click="updateBlogSort()">更新排序</el-button>
		  </div>
		</template>
		<el-table
		:data="list"
		tooltip-effect="dark"
		style="width: 100%"
		>
			<el-table-column label="排序" prop="sort_order">
				<template v-slot="scope">
				    <el-input :style="{'width':'40%'}" type="text" v-model="scope.row.sort_order"></el-input>
				</template>
			</el-table-column>
			<el-table-column label="图片">
				<template v-slot="scope">
					<el-image class="product-img-small" v-if="scope.row.thumbnail" :src="this.getImgPrefix()+scope.row.thumbnail"
					 fit="contain" lazy>
					</el-image>
				</template>
			</el-table-column>
			<el-table-column label="标题" prop="title">
			</el-table-column>
			<el-table-column label="简述" prop="sketch">
			</el-table-column>
			<el-table-column label="开始时间">
				<template v-slot="scope">
					{{timestampToTime(scope.row.start_time)}}
				</template>
			</el-table-column>
			<el-table-column label="结束时间">
				<template v-slot="scope">
					{{timestampToTime(scope.row.end_time)}}
				</template>
			</el-table-column>
			<el-table-column
			  label="开启状态"
			>
			  <template #default="scope">
					<el-switch
						v-model="scope.row.status"
						active-color="#409EFF"
						inactive-color="#F56C6C"
						:active-value="1"
						:inactive-value="2"
						@change="changeEnabled(scope.row.status, scope.row.id)">
					</el-switch>
			  </template>
			</el-table-column>
			<el-table-column
			  label="操作"
			  width="auto"
			>
			  <template #default="scope">
						  <el-button type="primary" size="mini" @click="editBlog(scope.row)">编辑</el-button>
						  <el-button type="warning" size="mini" @click="delBlog(scope.row)">删除</el-button>
			  </template>
			</el-table-column>
		</el-table>
	</el-card>	
	<el-dialog title="编辑" v-model="dialogFormVisible">
		<div class="col">
			<el-form  label-position="right" label-width="100px" :model="form" ref="form" :rules="rules">
				<el-form-item label="图片">
					<upload buttonTitle='上传' upload_path='upload_blog' :resize='750' @success-upload='imgSuccess_SingleFile'></upload>
					<div class="row-no-full" style="flex-wrap: wrap;">
						<div style="margin-right: 30px;">
							<div class="col">
								<div class="demo-image__preview">
									<el-image v-if="form.thumbnail && form.thumbnail!=''" :src='this.getImgPrefix()+form.thumbnail' style='width: 120px;' fit='contain' ></el-image>
								</div>
							</div>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="标题" prop="title" >
					<el-input v-model="form.title" size="small" placeholder="标题"></el-input>
				</el-form-item>
					<el-form-item label="简述" prop="sketch" >
					<el-input v-model="form.sketch" size="small" placeholder="简述"></el-input>
				</el-form-item>
				<el-form-item label="内容" prop="content">
					<ueditor ref='ue' v-model="form.content" :config="myconfig_ueditor"></ueditor>
				</el-form-item>
				<el-form-item label="开始时间" prop="start_time">
					<div class="block">
					    <el-input style="width: 220px;" v-model="form.start_time" type="date" placeholder="选择开始时间" autocomplete="off"></el-input>
					 </div>
				</el-form-item>
				<el-form-item label="结束时间" prop="end_time">
					<div class="block">
					    <el-input style="width: 220px;" v-model="form.end_time" type="date" placeholder="选择结束时间" autocomplete="off"></el-input>
					  </div>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import Ueditor from '../common/Ueditor.vue'
	import Upload from '../common/Upload.vue'
	export default{
		name: 'BlogList',
		components:{
			Ueditor,
			Upload,
		},
		data(){
			return{
				myconfig_ueditor: {
					UEDITOR_HOME_URL: '/UEditor/',
					serverUrl: this.getEnv('host') + '/admin/ueditor/ueditor',
					autoHeightEnabled: false,
					initialFrameHeight: 400,
					initialFrameWidth: '100%',
					zIndex:999999,
					toolbars: [
						['source', '|', 'undo', 'redo', '|', 'bold', 'italic',
							'underline', 'strikethrough', '|', 'superscript', 'subscript', '|',
							'forecolor', 'backcolor', '|', 'removeformat', '|',
							'insertorderedlist', 'insertunorderedlist', '|', 'selectall',
							'cleardoc', 'paragraph', '|', 'fontfamily', 'fontsize',
							'|', 'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify',
							'|', 'link', 'unlink', '|', 'emotion', 'simpleupload', 'insertimage',
							'video', '|', 'map', '|', 'horizontal', 'print', 'preview',
							'fullscreen', 'drafts', 'formula'
						]
					] //需要展示的按钮
				},
				loading:true,
				list:[],
				dialogFormVisible:false,
				thumbList:[],
				sort_orders_string:[],
				form:{
					thumbnail:[],
					title:'',
					sketch:'',
					content:'',
					start_time:'',
					end_time:'',
					sort_order:0,
					
				},
				rules: {
					title: [{
						required: true,
						message: '请填写标题',
						trigger: 'blur'
					}],
					sketch: [{
						required: true,
						message: '请填写简述',
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: '请填写内容',
						trigger: 'blur'
					}],
					start_time:[{
						required: true,
						message: '请填写开始时间',
						trigger: 'blur'
					}],
					end_time:[{
						required: true,
						message: '请填写结束时间',
						trigger: 'blur'
					}],
				},
			}
		},
		
		methods:{
			getBlog(){
				this.httpPost({
					url:'/admin/homeSetting/blog_list',
					data: {
						routePath: this.$route.path
					}
				}).then((res)=>{
					// console.log(res);
					this.list=res.data;
					this.loading=false;
				console.log(this.list);
				})
			},
			changeEnabled(status, id){
				let select_id = id;
				let change_status = status;
				if(select_id){
					this.loading=true;
					this.httpPost({
						url:'/admin/homeSetting/change_blog_status',
						data:{id:select_id,status:change_status}
					}).then((res)=>{
						if(res.code ==1){
							this.$message.success(res.msg);
							this.loading =false;
						}
					})
				}
			},
			editBlog(val){
				this.dialogFormVisible=true;
				let temp = this.cloneObj(val);
				// console.log(this.$refs.ue)
				if (val) {
					temp.start_time = this.timestampToTime(temp.start_time);
					temp.end_time = this.timestampToTime(temp.end_time);
					this.form = temp;
					this.$nextTick(() => {
						this.$refs.ue.setText(temp.content); //回显 富文本内容
					})
				} else {
					this.resetObj(this.form);
					this.$nextTick(() => {
						this.$refs.ue.setText('',false); //回显 富文本内容
					})
				}
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			delBlog(val){
				let id = val.id;
				this.msgBoxAjax(
				  '提示',
				  '确定删除吗？',
				  "/admin/homeSetting/delBlog",
				  {id:id}).then((res) => {
				  // console.log(data);
				  if (res.code == 1) {
				    this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
				      this.getBlog();
				    });
				  }else{
							
				    this.messageCommon('错误',res.msg,'error');
				  }		
				});
			},
			updateBlogSort(){
				let ids = [];
				this.sort_orders_string =[];
				this.$confirm('此操作将更新排序, 是否继续?', '提示', {
				                        confirmButtonText: '确定',
				                        cancelButtonText: '取消',
				                        type: 'warning'
				                    }).then((re) => {
				                        for (let i in this.list){
				                            if (this.sort_orders_string.indexOf(this.list[i].sort_order) == '-1'){
				                                //==-1表示该字符串不在此数组,返回值为-1
				                                this.sort_orders_string.push(this.list[i].sort_order);
				                                ids.push({id:this.list[i].id,sort_order:this.list[i].sort_order});
				                            }else{
				                                this.$message.error('排序有重复值');
				                                this.sort_orders_string = [];
				                                return;
				                            }
				                        }
										// console.log(ids);return;
										this.httpPost({
											url:'/admin/homeSetting/updateBlogSort',
											data:ids
										}).then((res)=>{
											if(res.code ==1){
												this.$message.success(res.msg);
												this.getBlog();
											}
										})
				                    })
			},
			imgSuccess_SingleFile(e) {
				if (this.form.thumbnail.length > 0) {
					this.form.thumbnail ='';
				}
				this.form.thumbnail=e;
			},
			submit(){
				if(this.form.thumbnail==''){
					this.$message.error('图片未上传');
					return false;
				} 
				// return false;
				this.form.content = this.$refs.ue.getUEContent();
				// console.log(this.form)
				// return false;
				this.$refs['form'].validate((valid)=>{
					if(valid){
						this.updateBlog();
					}else{
						console.log('error submit!')
						return false;
					}
				})
				
			},
			updateBlog(){
				this.loading = true;
				let id = this.form.id;
				if (!id) id = '';
				this.httpPost({
					url:'/admin/homeSetting/modify_blog?id='+ id,
					data:this.form
				}).then((res)=>{
					if(res.code ==1){
						this.dialogFormVisible = false;
						this.$message.success(res.msg);
						this.loading = false;
						this.getBlog();
					}
				})
			}
		},
		created() {
			this.getBlog();
		}
	}
</script>

<style>
</style>
